var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.graficoDados.length > 0
    ? _c("app-plotly", {
        attrs: {
          nomeDiv: _vm.idDiv,
          dados: _vm.graficoDados,
          layout: _vm.layout
        }
      })
    : _c(
        "div",
        {
          staticClass: "empty",
          staticStyle: { width: "100%", height: "450px", padding: "50px" }
        },
        [
          _c("span", { staticClass: "texto" }, [
            _vm._v("Nenhum dado a ser exibido.")
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05de3bed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05de3bed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/Grafico.vue
// module id = null
// module chunks = 